import dayjs from 'dayjs'

export const maxYearsValidator = (
	years: number,
	message: any = { key: 'too-old' }
) => ({
	name: `max-${years}-years`,
	message,
	test(value) {
		if (!value) return true;

		const date = dayjs(value, 'DD.MM.YYYY')
		if (!date.isValid()) return false

		const limitDate = dayjs().subtract(years, 'year')
		return date.isAfter(limitDate) || date.isSame(limitDate, 'day')
	},
});